/**
 * Pagination - Reusable pagination controls
 *
 * Single Responsibility: Displays pagination info and navigation buttons.
 * Does NOT handle data fetching or page state management.
 */
package com.castly.admin.ui.podcasts.components

import androidx.compose.runtime.Composable
import com.castly.admin.ui.paginationButtonStyle
import com.castly.admin.ui.theme.AppTheme
import com.castly.admin.ui.theme.Typography
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun Pagination(
    currentPage: Int,
    totalCount: Int,
    pageSize: Int = 20,
    loading: Boolean = false,
    onPageChange: (Int) -> Unit
) {
    val colors = AppTheme.colors
    if (!loading && totalCount > 0) {
        val totalPages = (totalCount + pageSize - 1) / pageSize
        val startItem = (currentPage - 1) * pageSize + 1
        val endItem = minOf(currentPage * pageSize, totalCount)

        Div({
            attr("data-testid", "pagination-container")
            style {
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.SpaceBetween)
                alignItems(AlignItems.Center)
                marginTop(16.px)
                fontSize(Typography.base)
            }
        }) {
            // Page info
            Text("Showing $startItem-$endItem of $totalCount")

            // Navigation buttons
            Div({
                style {
                    display(DisplayStyle.Flex)
                    gap(8.px)
                }
            }) {
                Button({
                    attr("data-testid", "pagination-previous")
                    onClick { if (currentPage > 1) onPageChange(currentPage - 1) }
                    if (currentPage <= 1) disabled()
                    style { paginationButtonStyle(disabled = currentPage <= 1, colors = colors) }
                }) { Text("Previous") }

                Button({
                    attr("data-testid", "pagination-next")
                    onClick { if (currentPage < totalPages) onPageChange(currentPage + 1) }
                    if (currentPage >= totalPages) disabled()
                    style { paginationButtonStyle(disabled = currentPage >= totalPages, colors = colors) }
                }) { Text("Next") }
            }
        }
    }
}
